import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import GetAppIcon from '@material-ui/icons/GetApp';

export default function FilePreview({ fileInfo, toggleModalFn, downloadFile }) {
    const imageMedia = ['jpeg', 'jpg', 'png', 'gif', 'bmp'];
    return (
        <Dialog
            open={true}
            onClose={toggleModalFn}
            className='mou-dialog'
            fullScreen
        >
            
            <DialogTitle dividers={true} id="scroll-dialog-title">
                Preview for {fileInfo?.name ? fileInfo?.name :fileInfo?.file_name}
                <div style={{float:"right"}}>
                <Button color='primary' size='small' variant='outlined' style={{ marginRight: "10px" }} onClick={()=>downloadFile(fileInfo)}>
                <GetAppIcon color="primary" fontSize="small" /> Download
                </Button>
                </div>
            </DialogTitle>
            <DialogContent dividers={true} >
                {fileInfo?.extension.toLowerCase() =='pdf'?
                    <object type="text/html" data={`https://sparta-aims.ams3.digitaloceanspaces.com/others/tools/pdf.js/web/viewer.html?file=${encodeURIComponent( fileInfo.url ?  fileInfo.url : fileInfo.image)}#search=${window.location.search.substr(window.location.search.indexOf('?searchTerm=') + 12)}`} style={{ width: '99%', height: window.innerHeight - 120 }} >
                    <param name="type" value="text/html" />
                </object>
                :null}
                {['xls', 'xlsx', 'docx'].includes(fileInfo?.extension?.toLowerCase()) ? (
                    <iframe src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileInfo?.url ?fileInfo?.url : fileInfo?.image )}`} width='100%' height={window.innerHeight} frameborder='0' />
                ) : null}

                {fileInfo?.extension === 'csv' ? (
                    <object id="myObject" data={`https://sparta-aims.ams3.digitaloceanspaces.com/others/tools/xls_viewer/index.html?file=${encodeURIComponent(fileInfo?.url ? fileInfo?.url : fileInfo?.image)}`} style={{ width: '100%', height: window.innerHeight - 100 }} />
                ) : null}
               
                {imageMedia.includes(fileInfo?.extension.toLowerCase()) ?
                    <div style={{ textAlign: 'center' }}>
                        <img style={{ margin: '0 auto', maxHeight: window.innerHeight -100, maxWidth: window.innerWidth -100 }} src={fileInfo.url ? fileInfo.url : fileInfo?.image} alt="" />
                    </div> : null
                }
            </DialogContent>
            <DialogActions>
                <Button color='primary' size='small' variant='outlined' style={{ marginRight: "10px" }} onClick={toggleModalFn}>
                    Okay
                </Button>
            </DialogActions>
        </Dialog>
    )
}
